import { createContext, type PropsWithChildren, useContext, useEffect, useMemo } from 'react'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { BillingStore } from 'pages/settings/pages/billing/store/billingStore'

export const BillingViewContext = createContext<BillingStore | null>(null)

export const useBillingViewContext = () => {
  const context = useContext(BillingViewContext)

  if (context === null)
    throw new Error('You have forgotten to wrap your root component with BillingViewContext')

  return context
}

export const BillingViewProvider = ({ children }: PropsWithChildren) => {
  const entities = useEntitiesContext()
  const store = useMemo(() => new BillingStore(entities), [])

  useEffect(() => {
    void store.init()
  }, [])

  return <BillingViewContext.Provider value={store}>{children}</BillingViewContext.Provider>
}
